import StrainTerpenes from "./StrainTerpenes";

export default StrainTerpenes;
